import { _Base } from "./_Base";
import { endpoints } from "./endpoints";

export class Products extends _Base {
  getAllProducts() {
    const endPointRoot = process.env.REACT_APP_ROOT_T_REST;
    const url = endPointRoot + endpoints.product.all;
    var request = this.prepareGet(url, null);
    return request;
  }
}
